var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7882 16.5273L23.8348 22.5739C24.0551 22.7942 24.0551 23.1504 23.8348 23.3707L23.3707 23.8348C23.1504 24.0551 22.7942 24.0551 22.5739 23.8348L16.5273 17.7882C16.4242 17.6804 16.3633 17.5398 16.3633 17.3898V16.9117C14.6243 18.5147 12.3041 19.499 9.74952 19.499C4.36385 19.499 0 15.1352 0 9.74952C0 4.36385 4.36385 0 9.74952 0C15.1352 0 19.499 4.36385 19.499 9.74952C19.499 12.3041 18.5147 14.6243 16.907 16.3633H17.3898C17.5398 16.3633 17.6804 16.4195 17.7882 16.5273ZM1.5 9.74963C1.5 14.3103 5.18888 17.9992 9.7496 17.9992C14.3103 17.9992 17.9992 14.3103 17.9992 9.74963C17.9992 5.18892 14.3103 1.50003 9.7496 1.50003C5.18888 1.50003 1.5 5.18892 1.5 9.74963Z",
    fill: "#11304D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.28415306f09ea31f2db54dc4eb0417fd.svg";
export { ForwardRef as ReactComponent };